import { render, staticRenderFns } from "./Pmi.vue?vue&type=template&id=5288e95b&"
import script from "./Pmi.vue?vue&type=script&lang=js&"
export * from "./Pmi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports